import React from 'react';
import type { WAbsoluteThemeComponentAssetView } from '@zola/svc-web-api-ts-client';
import type { CroppedAbsoluteAssetDisplayType } from 'components/publicWebsiteV2/util/useCroppedBottomAbsoluteAssets';
import { mapAbsoluteAssetViewToStyledImg } from './mappers';

export const renderAbsoluteAssets = (
  a?: WAbsoluteThemeComponentAssetView[],
  elementsRef?: React.MutableRefObject<React.RefObject<HTMLImageElement>[]>,
  croppedDimensions?: CroppedAbsoluteAssetDisplayType[]
): (JSX.Element | null)[] | null => {
  if (a) {
    if (a.length > 0) {
      return a.map((abs: WAbsoluteThemeComponentAssetView, i: number) => {
        const { style, image_url } = abs || {};
        if (!image_url || !style?.responsive_size) return null;
        // const modifiedUrl = image_url.replace('stage-images', 'images');
        const Img = mapAbsoluteAssetViewToStyledImg(style?.responsive_size, croppedDimensions?.[i]);

        return (
          <Img
            src={image_url}
            alt={style?.alt_text}
            key={`asset-${i}`}
            ref={elementsRef?.current[i]}
          />
        );
      });
    }
  }
  return null;
};
